import React from "react"
import ReactDOM from "react-dom/client"
import "./tailwind.css"
import App from "./App"
import reportWebVitals from "./reportWebVitals"

const doc: any = document
const root = ReactDOM.createRoot(doc.getElementById("root"))
root.render(<App />)
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()

function sendHeight() {
	window.parent.postMessage(
		{
			type: 'iframe-height',
			height: document.documentElement.scrollHeight
		},
		'*'
	);
}

window.addEventListener('load', sendHeight);
window.addEventListener('resize', sendHeight);
new ResizeObserver(sendHeight).observe(document.body);
